import React from 'react';
import { 
  Box, Typography, IconButton, Button, 
  useMediaQuery, useTheme, FormGroup, Switch 
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import RefreshIcon from '@mui/icons-material/Refresh';
import ManagedModal from './ManagedModal';

export default function ReportColumnDrawer({
  open, 
  onClose, 
  columns = [], 
  hiddenCols = [], 
  onToggle,
  onReset
}) {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <ManagedModal
      type="drawer"
      anchor={isDesktop ? "right" : "bottom"}
      open={open}
      onClose={onClose}
      PaperProps={{ 
        sx: isDesktop 
          ? { 
              width: 340, borderRadius: 3, m: 2, height: 'auto', 
              maxHeight: 'calc(100vh - 32px)', display: 'flex', flexDirection: 'column',
              overflow: 'hidden', bgcolor: 'background.default'
            }
          : {
              borderTopLeftRadius: 24, borderTopRightRadius: 24, 
              pb: 'max(24px, env(safe-area-inset-bottom))', 
              maxHeight: '85vh', width: '100%', display: 'flex', flexDirection: 'column',
              bgcolor: 'background.default'
            } 
      }}
    >
      <Box sx={{ p: 2, display: 'flex',minHeight:"0px", flexDirection: 'column', height: '100%' }}>
          
          {!isDesktop && (
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
              <Box sx={{ width: 40, height: 4, bgcolor: 'divider', borderRadius: 2 }} />
            </Box>
          )}

          {/* Header */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6" fontWeight="bold" color="primary.main" sx={{ display: 'flex', alignItems: 'center' }}>
              <ViewColumnIcon sx={{ mr: 1 }} /> Hiển thị cột
            </Typography>
            <IconButton onClick={onClose} size="small" sx={{ bgcolor: 'action.hover' }}>
              <CloseIcon sx={{ fontSize: 20 }} />
            </IconButton>
          </Box>
          
          {/* Form Content */}
          <Box sx={{ overflowY: 'auto', px: 1, flexGrow: 1, mx: -1 }}>
            <FormGroup>
                {columns.map(col => {
                    const isHidden = hiddenCols.includes(col.field);
                    return (
                        <Box 
                            key={col.field} 
                            sx={{ 
                                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                p: 1, mb: 0.5, borderRadius: 2,
                                bgcolor: isHidden ? 'transparent' : 'background.paper',
                                border: '1px solid',
                                borderColor: isHidden ? 'transparent' : '#e5e5ea',
                                transition: 'all 0.2s'
                            }}
                        >
                            <Typography sx={{ color: isHidden ? 'text.secondary' : 'text.primary', fontWeight: isHidden ? 'normal' : '500' }}>
                                {col.label || col.field}
                            </Typography>
                            <Switch 
                                size="small"
                                checked={!isHidden} 
                                onChange={() => onToggle(col.field)} 
                                color="primary" 
                            />
                        </Box>
                    )
                })}
            </FormGroup>
          </Box>
          
          {/* Actions Footer */}
          <Box sx={{ mt: 3, pt: 2, borderTop: '1px solid #f0f0f0', display: 'flex', flexShrink: 0 }}>
            <Button 
                variant="outlined" 
                color="inherit" 
                fullWidth 
                startIcon={<RefreshIcon />} 
                onClick={onReset} 
                sx={{ borderRadius: 2, textTransform: 'none' }}
            >
              Khôi phục mặc định
            </Button>
          </Box>
          
      </Box>
    </ManagedModal>
  );
}